<template>
    <header class="section-item mb-5">
        <h3 class="is-size-5 has-text-weight-bold">
            {{title}}
        </h3>
        <p>{{description}}</p>
        <slot class="mt-2"></slot>
    </header>
</template>

<script>
export default {
    name: "SectionHeader",
    props: ['title','description']
}
</script>